<template>
  <div class="automated-communication-email elevation-4 pa-4">
    <img
      src="/src/assets/SOE_logo_avatar_black.svg"
      alt="so-logo"
      class="d-block mx-auto"
    />

    <p>Hello {{ enrolment.customerName }},</p>
    <p>We’re delighted you’ve chosen So Energy as your energy supplier.</p>

    <p>{{ emailDetails.paragraphOne }}</p>
    <p>{{ emailDetails.paragraphTwo }}</p>

    <ul v-if="emailDetails.isMpanInUse" class="ml-5">
      <li>
        Have you recently moved into the property? If so, please use our
        self-serve
        <SoLink :href="accountMoveInLink" class="link email-link">
          <div class="link-content">Move In Journey</div>
        </SoLink>
        on our website to process your change of tenancy.
      </li>
      <li>
        If you are the current occupier and already have an account with us,
        please use your
        <SoLink :href="accountLink" class="link">
          <div class="link-content">online account</div>
        </SoLink>
        to request a tariff renewal.
      </li>
    </ul>

    <p>
      If you have any further questions, please feel free to get back in touch.
      You can email us at any time at
      <SoLink href="mailto:help@so.energy" class="link">
        <div class="link-content">help@so.energy</div>
      </SoLink>
      or give us a call on
      <SoLink href="tel:03301115050" class="link">
        <div class="link-content">0330 111 5050</div></SoLink
      >
      (Monday to Friday, 9am to 5pm.).
    </p>
    <div>
      <p>Best wishes,</p>
      <p>The So Energy Team</p>
    </div>
  </div>
</template>

<script lang="ts">
  import { defineComponent, PropType } from "vue"
  import { Enrolment } from "@/models/operations/enrolment/enrolment"
  import { EnrolmentAutomatedCommunication } from "@/models/operations/enrolmentAutomatedCommunication/enrolmentAutomatedCommunication"
  import SoLink from "@/components/SoLink.vue"

  export default defineComponent({
    components: {
      SoLink,
    },
    props: {
      emailDetails: {
        type: Object as PropType<EnrolmentAutomatedCommunication>,
        required: true,
      },
      enrolment: {
        type: Object as PropType<Enrolment>,
        default: null,
        required: true,
      },
    },
    data: () => {
      return {
        accountLink: import.meta.env.SO_MY_ACCOUNT_URL,
        accountMoveInLink:
          import.meta.env.SO_MY_ACCOUNT_URL + "/move-in/move-in-address",
      }
    },
  })
</script>

<style scoped>
  .automated-communication-email {
    & > * {
      padding: 10px 25px;
    }

    p {
      font-family: Ubuntu, Helvetica, Arial, sans-serif;
      font-size: 13px;
    }

    li {
      font-family: Ubuntu, Helvetica, Arial, sans-serif;
      font-size: 13px;
    }

    img {
      height: 126px;
      padding: 0;
    }

    .link-content {
      font-family: Ubuntu, Helvetica, Arial, sans-serif;
      font-size: 13px;
    }
  }
</style>
